<div class="registration-step-title">
  <p *ngIf="dialogStep === 0" class="isidorasansalt-semi-bold-blue-38px">ÉTAPE 1 : Renseigner vos informations</p>
  <p *ngIf="dialogStep === 1" class="isidorasansalt-semi-bold-blue-38px">ÉTAPE 2 : Suis-je éligible pour devenir valet ?</p>
  <p *ngIf="dialogStep === 2" class="isidorasansalt-semi-bold-blue-38px">CONCLUSION</p>
</div>

<div class="registration-form-section">
  <ng-container *ngIf="formFirstStep">
    <nb-card-body *ngIf="dialogStep === 0" [formGroup]="formFirstStep">
      <div class="section-create-account">
        <div class="container-create-account">
          <div class="row">
            <div class="col-md-2 button-bottom-space">
              <nb-select
                formControlName="title"
                placeholder="{{'recruitment.popup.placeholder.title' | translate}}"
                fullWidth>
                <nb-option [value]="'Mr'">{{'recruitment.popup.answer_type_mister' | translate}}</nb-option>
                <nb-option [value]="'Mme'">{{'recruitment.popup.answer_type_madam' | translate}}</nb-option>
                <nb-option [value]="'Mlle'">{{'recruitment.popup.answer_type_miss' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['title']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
            <div class="col-md-5 button-bottom-space">
              <input formControlName="firstName" nbInput placeholder="{{'recruitment.popup.placeholder.first_name' | translate}}" fullWidth>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['firstName']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
            <div class="col-md-5">
              <input formControlName="lastName" nbInput placeholder="{{'recruitment.popup.placeholder.last_name' | translate}}" fullWidth>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['lastName']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row" style="margin-top: 30px">
            <div class="col-md-6">
              <pv-shared-input-phone-number
                [formGroup]="formFirstStep"
                controlName="phone">
              </pv-shared-input-phone-number>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['phone']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['phone']"
                  [validation]="'pattern'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
            <div class="col-md-6">
              <input formControlName="email" nbInput type="email" placeholder="{{'recruitment.popup.placeholder.email' | translate}}" fullWidth>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['email']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row" style="margin-top: 30px">
            <div class="col-md-6 button-bottom-space">
              <input formControlName="password" nbInput placeholder="{{'recruitment.popup.placeholder.password' | translate}}" [type]="'password'" fullWidth>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formFirstStep.controls['password']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
            <div class="col-md-6">
              <input formControlName="samePassword" nbInput placeholder="{{'recruitment.popup.placeholder.check_password' | translate}}" [type]="'password'" fullWidth>
            </div>
          </div>
          <div class="row mt-1" style="padding: 0 15px">
            <p>{{'recruitment.popup.forms.password_info' | translate}}</p>
          </div>
            <div class="row mt-1">
                <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_sourcing' | translate}}</p></div>
                <div class="col-md-4 m-auto">
                    <nb-select
                            placeholder="{{'recruitment.popup.placeholder.sourcing' | translate}}"
                            formControlName="sourcingType"
                            fullWidth>
                        <nb-option [value]="'wordOfMouth'">{{'recruitment.popup.answer_sourcing_word_of_mouth' | translate}}</nb-option>
                        <nb-option [value]="'facebook'">{{'recruitment.popup.answer_sourcing_facebook' | translate}}</nb-option>
                        <nb-option [value]="'popvaletWebsite'">{{'recruitment.popup.answer_sourcing_popvalet_website' | translate}}</nb-option>
                        <nb-option [value]="'google'">{{'recruitment.popup.answer_sourcing_google' | translate}}</nb-option>
                        <nb-option [value]="'assuranceAuto'">{{'recruitment.popup.answer_sourcing_assurance_auto' | translate}}</nb-option>
                        <nb-option [value]="'portailAutoentrepreneur'">{{'recruitment.popup.answer_sourcing_portail_autoentrepreneur' | translate}}</nb-option>
                        <nb-option [value]="'eliteConvoyeur'">{{'recruitment.popup.answer_sourcing_elite_convoyeur' | translate}}</nb-option>
                        <nb-option [value]="'other'">{{'recruitment.popup.answer_sourcing_other' | translate}}</nb-option>
                    </nb-select>
                    <slnk-shared-input-validator>
                        <slnk-shared-input-validator-item
                                [validationFormControl]="formFirstStep.controls['sourcingType']"
                                [validation]="'required'">
                        </slnk-shared-input-validator-item>
                    </slnk-shared-input-validator>
                </div>
                <div class="col-12" *ngIf="this.formFirstStep.get('sourcingType').value === 'other'">
              <textarea nbInput
                        placeholder="{{'recruitment.popup.placeholder.sourcing_note' | translate}}"
                        fullWidth
                        formControlName="sourcingNote">
              </textarea>
                </div>
            </div>
          <div class="row" style="margin-top: 30px">
            <div class="col-md-6">
              <input formControlName="referralCode"
                     nbInput
                     placeholder="{{((formFirstStep.controls['referralCode'].validator | hasValidator: 'required') ? 'recruitment.popup.placeholder.code' : 'recruitment.popup.placeholder.code_optional') | translate}}"
                     fullWidth>
            </div>
          </div>
          <div class="mt-2">
            <p>Les données recueillies via ce formulaire sont traitées par Pop Valet aux fins de gérer votre inscription à nos services. <a [href]="'https://popvalet.com/recruitment-privacy-policy'">En savoir plus sur la gestion de vos données et vos droits.</a></p>
          </div>
          <div class="mt-2" style="text-align: center">
            <nb-checkbox status="success" [checked]="useMyData" (checkedChange)="useMyData = !useMyData">
              <p style="font-weight: bold; text-align: left">{{'recruitment.popup.use_my_data' | translate}}</p>
            </nb-checkbox>
          </div>
        </div>
      </div>
    </nb-card-body>

    <nb-card-body class="dialog-container-center" *ngIf="dialogStep === 1" [formGroup]="formSecondStep">
      <div class="d-flex align-items-center flex-column">
        <div class="registration-step-questions">
          <div class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_metropolis' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <pv-common-autocomplete
                formControlName="metropolis"
                [placeholder]="'recruitment.popup.placeholder.metropolis' | translate"
                [selectItems]="availableMetropolis">
              </pv-common-autocomplete>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['metropolis']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_autoentrepreneur' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="hasAutoentrepreneurStatus"
                fullWidth>
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['hasAutoentrepreneurStatus']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div *ngIf="formSecondStep.controls['hasAutoentrepreneurStatus'].value === false">
            <p style="font-weight: bold">{{'recruitment.popup.auto_entrepreneur_offers_title' | translate}}</p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
          <div *ngIf="formSecondStep.controls['hasAutoentrepreneurStatus'].value" class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_tva' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="noTVA"
                fullWidth>
                <nb-option [value]="false">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="true">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['noTVA']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div *ngIf="formSecondStep.controls['noTVA'].value == false" class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_tva_number' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input formControlName="vatNumber"
                     nbInput
                     placeholder="{{'recruitment.popup.placeholder.tva_number' | translate}}"
                     fullWidth>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['vatNumber']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['vatNumber']"
                  [validation]="'pattern'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div *ngIf="formSecondStep.controls['hasAutoentrepreneurStatus'].value" class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_siret' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input formControlName="siret"
                     nbInput
                     placeholder="{{'recruitment.popup.placeholder.siret' | translate}}"
                     fullWidth
                     maxlength="14">
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['siret']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['siret']"
                  [validation]="'pattern'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_license_points' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input nbInput
                     fullWidth
                     formControlName="drivingLicensePoints"
                     type="number"
                     min="0" max="12"
                     (change)="checkLicencePoints()"
                     placeholder="{{'recruitment.popup.placeholder.driving_license_points' | translate}}">
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['drivingLicensePoints']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_license_age' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.driving_license_age' | translate}}"
                formControlName="drivingLicenseAge"
                fullWidth>
                <nb-option [value]="'moreThanOrEqual5'">{{'recruitment.popup.answer_license_age_more' | translate}}</nb-option>
                <nb-option [value]="'lessThan5'">{{'recruitment.popup.answer_license_age_less' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['drivingLicenseAge']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_license_type' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.driving_license_type' | translate}}"
                formControlName="drivingLicenseType"
                fullWidth>
                <nb-option [value]="'european'">{{'recruitment.popup.answer_european' | translate}}</nb-option>
                <nb-option [value]="'foreign'">{{'recruitment.popup.answer_foreign' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['drivingLicenseType']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_licenses_types' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select fullWidth
                         formControlName="licensesTypes"
                         [multiple]="true"
                         placeholder="{{'recruitment.popup.placeholder.licenses_types' | translate}}">
                <nb-option-group *ngFor="let group of licensesTypesGroups"
                                 [title]="group.name"
                                 style="font-weight: bold;">
                  <nb-option *ngFor="let type of group.types"
                             [value]="type.value">
                    {{type.name}}
                  </nb-option>
                </nb-option-group>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['licensesTypes']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_drives_VU' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="drivesVU"
                fullWidth>
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['drivesVU']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_nationality' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.nationality' | translate}}"
                formControlName="nationality"
                fullWidth>
                <nb-option [value]="'european'">{{'recruitment.popup.answer_european' | translate}}</nb-option>
                <nb-option [value]="'foreign'">{{'recruitment.popup.answer_foreign' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['nationality']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_available_on_saturday' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="availableOnSaturday"
                fullWidth>
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['availableOnSaturday']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_insurer' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="hasInsurer"
                fullWidth>
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false" (click)="resetFile()">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['hasInsurer']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <ng-container [ngSwitch]="formSecondStep.get('hasInsurer').value">
            <div *ngSwitchCase="true">
              <div class="row">
                <div class="col"><p style="font-weight: bold">{{'recruitment.popup.question_insurer_info' | translate}}</p></div>
              </div>
              <div class="row">
                <button nbButton
                        status="primary"
                        class="ml-3 mb-2"
                        fullWidth
                        (click)="fileInput.click()">
                  {{'recruitment.popup.question_insurer_add_document' | translate}}
                </button>
                <input type="file"
                       class="d-none"
                       #fileInput
                       [accept]="acceptedValetFileTypes"
                       (change)="fileInputChanged($event.target.files[0])">
              </div>
            </div>
            <div *ngSwitchCase="false">
              <div class="row">
                <div class="col"><p style="font-weight: bold">{{'recruitment.popup.question_insurer_orus_info' | translate}}</p></div>
              </div>
              <div class="row">
                <button nbButton
                        status="primary"
                        class="ml-3 mb-2"
                        fullWidth
                        (click)="redirectToOrusSubscribePage()">
                  {{'recruitment.popup.question_insurer_orus_subscribe' | translate}}
                </button>
              </div>
            </div>
          </ng-container>
          <div class="row" *ngIf="fileName">
            <div class="col"><p style="font-weight: bold">{{'recruitment.popup.question_insurer_document_added' | translate}} {{fileName}}</p></div>
          </div>
          <div class="row mt-1">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_has_w_garage' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <nb-select
                placeholder="{{'recruitment.popup.placeholder.yes_or_no' | translate}}"
                formControlName="hasWGarage"
                fullWidth
                (selectedChange)="updateWGarageValidators($event)">
                <nb-option [value]="true">{{'recruitment.popup.answer_yes' | translate}}</nb-option>
                <nb-option [value]="false">{{'recruitment.popup.answer_no' | translate}}</nb-option>
              </nb-select>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['hasWGarage']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
          <div class="row" *ngIf="formSecondStep.get('hasWGarage').value">
            <div class="col-md-8"><p style="font-weight: bold">{{'recruitment.popup.question_w_garage' | translate}}</p></div>
            <div class="col-md-4 m-auto">
              <input nbInput
                     fullWidth
                     formControlName="wGarage"
                     type="text"
                     placeholder="{{'recruitment.popup.placeholder.w_garage' | translate}}">
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['wGarage']"
                  [validation]="'required'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
              <slnk-shared-input-validator>
                <slnk-shared-input-validator-item
                  [validationFormControl]="formSecondStep.controls['wGarage']"
                  [validation]="'pattern'">
                </slnk-shared-input-validator-item>
              </slnk-shared-input-validator>
            </div>
          </div>
        </div>
      </div>
    </nb-card-body>

    <nb-card-body class="dialog-container-center" *ngIf="dialogStep === 2">
      <div class="d-flex align-items-center flex-column" *ngIf="eligibility === 'valid'">
        <div class="registration-step-conclusion">
          <div class="d-flex justify-content-center align-items-center">
            <img src="assets/images/check-symbol.png" style="height: 33px" alt="">
            <p style="font-weight: bold; font-size: 18px;" class="ml-2">{{'recruitment.popup.eligibility_valid' | translate}}</p>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center flex-column" *ngIf="eligibility === 'invalid'">
        <div class="registration-step-conclusion">
          <div class="d-flex justify-content-center align-items-center">
            <img src="assets/images/error-symbol.png" style="height: 33px" alt="error">
            <p style="font-weight: bold; font-size: 18px;" class="ml-2">{{'recruitment.popup.eligibility_invalid' | translate}}</p>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="showAutoentrepreneurCreationMessage()">
            <p style="font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_reason' | translate}}
            </p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
          <div class="d-flex flex-column justify-content-center align-items-center" *ngIf="showEligibilityInvalidMessage()">
            <p style="font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.reasons' | translate}} :<br>
            </p>
            <p style="font-size: 16px; font-weight: 600;" class="mt-2 w-100">
              <span *ngIf="this.candidate.hasAutoentrepreneurStatus === false" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_status' | translate}}
                <br>
              </span>
              <span *ngIf="this.candidate.drivingLicensePoints < 8" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_points' | translate}}
              </span>
              <br>
              <span *ngIf="this.candidate.drivingLicenseAge === 'lessThan5'" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_age' | translate}}
              </span>
              <br>
              <span *ngIf="this.candidate.drivingLicenseType === 'foreign'" class="mb-2">
                - {{'recruitment.popup.eligibility_invalid_reasons.driving_license_type' | translate}}
              </span>
            </p>
            <p style="font-size: 16px; font-weight: 600;" class="mt-2">
              {{'recruitment.popup.eligibility_invalid_reasons.autoentrepreneur_proposition' | translate}}
            </p>
            <ng-container *ngTemplateOutlet="autoEntrepreneurOffers"></ng-container>
          </div>
        </div>
      </div>
    </nb-card-body>
  </ng-container>

  <div class="eligibility-footer-buttons"
       [ngClass]="{'single-button': visibleButtonsCount === 1, 'multiple-buttons': visibleButtonsCount > 1}">
    <button nbButton class="popup-button ml-2" status="primary"
            *ngIf="dialogStep === 0 && !blockedValet"
            (click)="nextStep()">{{'recruitment.popup.button_next' | translate}}</button>

    <button nbButton class="popup-button ml-2" status="primary"
            *ngIf="dialogStep === 1"
            (click)="previousStep()">{{'recruitment.popup.button_previous' | translate}}</button>
    <button nbButton class="popup-button eligibility-create-button ml-2" status="primary"
            *ngIf="dialogStep === 1"
            [disabled]="isSubmitting"
            [nbSpinner]="isSubmitting"
            (click)="createAccountOrRetry()">{{'recruitment.popup.button_create' | translate}}</button>
    <button nbButton class="popup-button eligibility-create-button ml-2" status="primary"
            *ngIf="showConnectButton && (this.dialogStep !== 2)"
            (click)="showConnexionDialog()">{{'recruitment.popup.button_connexion' | translate}}</button>

    <button nbButton class="popup-button start-recruitment" status="primary"
            *ngIf="(dialogStep === 2) && (eligibility === 'valid')"
            (click)="startRecruitmentProcess()">{{'recruitment.popup.button_recruitment_process' | translate}}</button>
  </div>
</div>

<ng-template #autoEntrepreneurOffers>
  <div class="auto-entrepreneur-offers-section">
    <div class="auto-entrepreneur-offer-col">
      <p style="font-weight: bold">{{'recruitment.popup.auto_entrepreneur_qonto_text' | translate}}</p>
      <button nbButton
              status="primary"
              fullWidth
              (click)="redirectToQonto()">
        {{'recruitment.popup.auto_entrepreneur_qonto_button' | translate}}
      </button>
    </div>
    <div class="auto-entrepreneur-offer-col">
      <p style="font-weight: bold">{{'recruitment.popup.auto_entrepreneur_portail_text' | translate}}</p>
      <button nbButton
              status="primary"
              fullWidth
              (click)="redirectToPortailAutoEntrepreneur()">
        {{'recruitment.popup.auto_entrepreneur_portail_button' | translate}}
      </button>
    </div>
  </div>
</ng-template>
